import React from "react";
import InfoIcon from "../../../Assets/images/icon-info-circle.svg";

const ActionPlanInfo = (props: any) => {
    return (
        <>
            <div className="dialog-header" style={{ display: "flex", marginBottom: "unset" }}>
                <div className="dialog-icon status-default" style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <img src={InfoIcon} alt="Circle with the letter 'i' in the center, signifying information" />
                </div>
                <div className="box-title-text">
                    <h2 className="box-title breach-dialog-title">Action Plan</h2>
                </div>
            </div>
            <div className="dialog-body margin-left-xs">
                <div className="row">
                    <div className="col-xs-2 col-sm-1"></div>
                    <div className="col-xs-8 col-sm-10">
                        <p className="risk-rating-description">
                            Breaches create serious risks for your identity, but fortunately there is a lot you can do to protect yourself. Key steps to protect
                            your identity are listed here, with the most important ones appearing at the top of the list.
                        </p>
                    </div>
                </div>
            </div>
            <div className="dialog-footer">
                <div className="row justify-center">
                    <div className="col-xs col-no-gutter flex-grow-null">
                        <button type="button" className="btn-default btn-primary" onClick={props.closeDialog}>
                            <span className="btn-text">Close</span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ActionPlanInfo;
